const sidebar = (state = {
    expanded: true
}, action) => {
    switch (action.type) {
        case 'SIDEBAR_CONFIG_FETCH_SUCCEEDED':
            if (!action.payload.config) {
                return state;
            }

            return Object.assign({}, state, action.payload.config);

        case 'SIDEBAR_COLLAPSE_REQUESTED':
            return Object.assign({}, state, {
                expanded: false
            });

        case 'SIDEBAR_EXPAND_REQUESTED':
            return Object.assign({}, state, {
                expanded: true
            });

        default:
            return state;
    }
}

export default sidebar;
